var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44.966 45",
    fill: "currentColor",
    enableBackground: "new 0 0 44.966 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.966,21.554c-0.526-8.462-4.545-14.797-11.951-18.921c-3.545-1.974-7.413-2.841-11.456-2.592 C13.113,0.562,6.792,4.574,2.647,11.943c-1.54,2.738-2.354,5.723-2.573,8.862C0.066,20.933,0.026,21.058,0,21.185 c0,0.879,0,1.758,0,2.636c0.116,0.866,0.188,1.741,0.355,2.597c1.477,7.565,5.7,13.048,12.602,16.449 c2.477,1.221,5.125,1.88,7.887,2.061c0.114,0.008,0.226,0.047,0.339,0.072c0.879,0,1.758,0,2.637,0 c0.868-0.116,1.744-0.19,2.603-0.355c7.125-1.37,12.45-5.248,15.94-11.594C44.324,29.482,45.218,25.612,44.966,21.554z  M22.476,38.461c-5.671-0.199-10.244-2.485-13.281-7.251c-3.671-5.761-3.61-11.722,0.036-17.497 c3.052-4.834,8.523-7.248,13.245-7.102C22.476,17.205,22.476,27.8,22.476,38.461z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDarkMode);
export default __webpack_public_path__ + "static/media/light-dark-mode.44f701bda0af14f17d74f30a62d6cc9c.svg";
export { ForwardRef as ReactComponent };